import { Button, Pagination, Space, Table } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

const TimedPublishTaskTableSection = ({
  columns,
  dataSource,
  loading,
  selectedTaskKeys,
  toggleSelectAllCurrentPage,
  isAllCurrentPageSelected,
  handleBatchDelete,
  clearSelection,
  pagination,
  onPageChange,
  onPageSizeChange,
}) => (
  <>
    <div className="page-panel__body">
      <Table
        columns={columns}
        dataSource={dataSource}
        rowKey="task_id"
        loading={loading}
        scroll={{ x: 3200 }}
        rowSelection={{
          selectedRowKeys: selectedTaskKeys,
          onChange: (keys) => {
            clearSelection(keys);
          },
        }}
        pagination={false}
      />
    </div>

    <div className="page-panel__bottom" style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '12px 16px 0',
      background: '#fff',
    }}
    >
      <div>
        {selectedTaskKeys.length > 0 && (
          <Space>
            <Button onClick={toggleSelectAllCurrentPage}>
              {isAllCurrentPageSelected ? '取消全选(本页)' : '全选本页'}
            </Button>
            <span>已选择 {selectedTaskKeys.length} 项</span>
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={handleBatchDelete}
            >
              批量删除
            </Button>
            <Button onClick={() => clearSelection([])}>清空全部</Button>
          </Space>
        )}
      </div>
      <Pagination
        current={pagination.current}
        pageSize={pagination.pageSize}
        total={pagination.total}
        showTotal={(total) => `共 ${total} 条记录`}
        showSizeChanger
        showQuickJumper
        style={{ margin: 0 }}
        onChange={onPageChange}
        onShowSizeChange={onPageSizeChange}
      />
    </div>
  </>
);

export default TimedPublishTaskTableSection;
